(function () {
    'use strict';
    var controllerId = 'stampaTestStak';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'testId', stampaTest]);

    function stampaTest($scope, datacontext, $uibModalInstance, testId) {
        $scope.item = {};
        $scope.item.testId = testId;
        $scope.item.test;

        getTest();

        function getTest() {
            datacontext.stak_test_get($scope.item.testId).then(function (test) {
                datacontext.stak_question_getAllByTest($scope.item.testId, 'sequence').then(function (data) {
                    if (Array.isArray(data) && data.length > 0) {
                        data.forEach(function (item) {
                            if (Array.isArray(item.choices) && item.choices.length > 0 && item.choices.length < 4) {
                                var t = 4 - item.choices.length;
                                for (var i = 0; i < t; i++) {
                                    item.choices.push({ "text": "", "layout": 1, "correct": false, "score": 0 });
                                }
                            }
                        });

                        $scope.item.questions = data;
                    }                    
                });
                $scope.item.test = test;
            });
        }
                
        $scope.print = function () {            
            document.title = "Siverapp - Test dimostrativo";
            window.print();  
        };
        
        $scope.ok = function () {            
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };       
    }
})();